import Cookies from 'js-cookie'
import { STORAGE } from 'shared/enums/SitePreferences'
import { v4 as uuidv4 } from 'uuid'

/**
 * Generate anonymous user id on the client side.
 *
 * It generates a new id if it doesn't exist and stores it
 * in a cookie to be used to track anonymous users across sessions.
 */
export const setClientAnonymousUserId = (options?: { overwrite?: boolean }) => {
  const { overwrite = false } = options || {}
  const auuid = (!overwrite && Cookies.get(STORAGE.ANONYMOUS_USER_ID)) || uuidv4()
  Cookies.set(STORAGE.ANONYMOUS_USER_ID, auuid, { expires: 365, path: '/' })
}

export const getClientAnonymousUserId = () => {
  const auuid = Cookies.get(STORAGE.ANONYMOUS_USER_ID)
  if (!auuid) {
    return setClientAnonymousUserId()
  }
  return auuid
}

/**
 * Set device id in cookies.
 *
 * It generates a new device id if it doesn't exist and stores it
 * in a cookie to be used by analytics platforms (i.e. Darwin, mParticle).
 */
export const setClientDeviceId = () => {
  const deviceId = Cookies.get(STORAGE.DEVICE_ID) || uuidv4()
  Cookies.set(STORAGE.DEVICE_ID, deviceId, { expires: 365, path: '/' })
  return deviceId
}

export const getClientDeviceId = () => {
  const deviceId = Cookies.get(STORAGE.DEVICE_ID)
  if (!deviceId) {
    return setClientDeviceId()
  }
  return deviceId
}
